import { CSSObject } from '@mantine/core';
import { MantineThemeComponent } from '../../types';
import { textVariants } from '../../tokens/typography/typography';

const MenuDefaultConfig: MantineThemeComponent = {
	styles: () => ( {
		inner: {
			padding: 0
		},
		item: {
			padding: '4px 24px 4px 12px',
			color: 'dark.7',
			...( textVariants[ 'footnote-semibold' ] as CSSObject )
		},
		itemIcon: {
			marginRight: '6px'
		}
	} )
};

export default MenuDefaultConfig;
